import ChessRestApi from '@/Api/ChessRestClient';
import {LoginResponse} from './types';
import {useMutation} from '@tanstack/react-query';
import {Readable} from 'stream';

export default function useSyncGamesApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<
    void,
    Error,
    {
      lichessUser: string;
      chessdotcomUser: string;
      ccUser: string;
      player_id?: number;
      userEmail: string;
      selectedPlayer?: {name: string; dob: string; fide_id: number};
      name?: string;
      dob?: string;
      gender?: string;
      player_type: number;
      pincode: string;
    }
  >(
    async (importGames: any) => {
      console.log('Calling API to import games ..');
      const {
        lichessUser,
        chessdotcomUser,
        ccUser,
        selectedPlayer,
        player_id,
        userEmail,
        name,
        dob,
        gender,
        player_type,
        pincode,
      } = importGames;
      console.log(selectedPlayer, 'selectedPlayer');
      const response = await ChessRestApi.post(
        'game/v1/learning/import_games/',
        {
          ...(chessdotcomUser ? {chessdotcomUser: chessdotcomUser} : {}),
          ...(lichessUser ? {lichessUser: lichessUser} : {}),
          ...(player_id ? {player_id: player_id} : {}),
          ...(userEmail ? {userEmail: userEmail} : {}),
          ...(name ? {name: name} : {}),
          ...(dob ? {dob: dob} : {}),
          ...(gender ? {gender: gender} : {}),
          ...(player_type ? {player_type: player_type} : {}),
          ...(pincode ? {pincode: pincode} : {}),
          ccUser: ccUser,
          ...(selectedPlayer?.name
            ? {
                name: selectedPlayer?.name,
                ...(selectedPlayer?.dob ? {dob: selectedPlayer?.dob} : {}),
                ...(selectedPlayer?.fide_id
                  ? {fide_id: selectedPlayer?.fide_id}
                  : {}),
              }
            : {}),
        },
      );
      console.log('Reponse = ', response);
      return response;
    },
    {
      onSuccess: data => {
        console.log('Executing onSuccess .. ', data);
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        console.log('Executing onError .. ', error);
        if (handleOnError) handleOnError(error); // Handle error logic here
      },
    },
  );

  return {
    ...mutation,
  };
}
